import { stringify as stringifyBase, stringifyUrl as stringifyUrlBase, } from 'query-string';
/**
 * オブジェクトをクエリ文字列に変換
 */
export const stringify = (queryObject) => stringifyBase(queryObject);
/**
 * オブジェクトをクエリ文字列でURLに変換
 */
export const stringifyUrl = (urlObject) => stringifyUrlBase(urlObject);
